import React from 'react'
import cn from 'classnames'
import styles from './SortHandler.module.scss'
import { HolderOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'

interface Props {
  id: string | number
}

export const TableSortHandler = ({ id }: Props) => {
  const {
    attributes,
    listeners,
    isDragging,
  } = useSortable({ id })

  return (
    <div className={cn(styles.root, isDragging && styles.dragging)} {...attributes} {...listeners}>
      <HolderOutlined />
    </div>
  )
}
